module.exports = __webpack_public_path__ + "static/media/instaptoets.c0061162.svg";